import { render, staticRenderFns } from "./DevAreaLocationForm.vue?vue&type=template&id=5a735c3e&"
import script from "./DevAreaLocationForm.vue?vue&type=script&lang=js&"
export * from "./DevAreaLocationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports